<template>
  <b-row>
    <b-col class="mb-2" cols="12">
      <h1>Активность по поставкам</h1>
    </b-col>

    <b-col cols="12" class="mt-2">
      <tsoft-wrapper :loading="!isLoad">
        <div class="d-flex justify-content-flex-start align-items-center mb-4">
          <div class="user-selector">
            <tsoft-select-user
              id="order-service-report-select-user"
              :roles="`logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager`"
              :selectedArray="user_ids"
              :needNullElement="false"
              :needMultipleSelect="true"
              @set="setUserId"
            ></tsoft-select-user>
          </div>
          <div class="choose-user ml-2">
            <b-form-checkbox
              v-model="isGroupByUser"
              class="ml-2"
              name="is-group-by-user-check-button" switch
            >
              Группировать по сотрудникам
            </b-form-checkbox>
          </div>
          <div class="choose-user ml-2">
            <b-form-checkbox
              v-model="isNotClosedOrders"
              class="ml-2"
              name="is-group-by-user-check-button" switch
              title="Показывать только не закрытые поставки (не в статусе Завершен, Закрыт, Ожидает оплаты, Отказ)"
            >
              Не закрытые поставки
            </b-form-checkbox>
          </div>
        </div>
        <ActiveHistory
          :userIds="user_ids"
          :isGroupByUser="isGroupByUser"
          :isNotClosedOrders="isNotClosedOrders"
          :key="activeHistoryKey"
          @isLoad="setIsLoad"
        />        
      </tsoft-wrapper>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";

import ActiveHistory from "@components/orders/orderServiceTemplate/v2/ActiveHistory.vue";

export default {
  components: {
    ActiveHistory
  },

  data() {
    return {
      isGroupByUser: false,
      isNotClosedOrders: true,
      user_ids: [],
      activeHistoryKey: 0,
      isLoad: true
    };
  },

  computed: {
    ...mapGetters("auth", ["currentUser", "statusUser", "headDepartment", "roleNoHead"]),
  },

  created() {
    if (this.currentUser.role.includes("logistics-manager") ||
        this.currentUser.role.includes("logistics-head-manager")) {
          this.setUserId([this.currentUser.id]);
    }
  },
  methods: {
    setUserId(ids) {
        if (JSON.stringify(this.user_ids) !== JSON.stringify(ids)) {
            this.user_ids = ids;
        }
    },
    setIsLoad(val) {
      this.isLoad = val;
    }
  },
};
</script>
